﻿import AriaTablist from 'aria-tablist';
import Glide, { Controls, Breakpoints, Swipe } from '../../node_modules/@glidejs/glide/dist/glide.modular.esm';
import { menuToggle } from './modules/topnav.js';
import { dropdownClicked } from './modules/topnav.js';
//import { autoScrollBanner } from './modules/headerBanner.js';
import { projectsFilter } from './modules/projectsFilter.js';
import { projectStatus } from './modules/projectStatus.js';
import { detectDevice } from './modules/detectDevice.js';
import { jobListingClickEvent } from './modules/jobListingClickEvent.js';
import { timeline } from './modules/timeline.js';
import { formValidation } from './modules/formValidation.js';
import { CookieAccept } from './modules/cookie.js';
import { formsPostcode } from './modules/formsPostcode.js';
import { coverageCheckerSpecial } from './modules/coverageCheckerSpecial.js';
import { accordion } from './modules/accordion.js';
import { packageSelect } from './modules/packageSelect.js';
import { sliderVideoModal } from './modules/sliderVideoModal.js'
import { CloseableBanner } from './modules/closeableBanner.js';

//window.onload = function () { autoScrollBanner(document.querySelector("#scroll-text")) };
window.dropdownClicked = dropdownClicked;
menuToggle();
detectDevice();
formValidation();
CookieAccept();
formsPostcode();
coverageCheckerSpecial();
sliderVideoModal();
CloseableBanner();

const sliders = document.getElementsByClassName('glide');

if (sessionStorage.getItem("referrer") === null) {
    sessionStorage.setItem("referrer", document.referrer);
}

for (let i = 0; i < sliders.length; i++) {
    const className = 'glide-' + (i + 1)
    sliders[i].classList.add('glide-' + (i + 1));

    new Glide("." + className).mount({ Controls, Breakpoints, Swipe });
}
if (document.getElementsByClassName('timeline').length) {
    timeline();
}

if (document.getElementById('tablist')) {
    AriaTablist(document.getElementById('tablist'));
}

if (document.getElementById('BambooHR')) {
    jobListingClickEvent();
}

if (document.getElementById('selectCounty')) {
    projectsFilter();
}

if (document.getElementsByClassName('project-status').length) {
    projectStatus();
}

if (document.getElementsByClassName('project-status').length) {
    projectStatus();
}

if (document.getElementsByClassName('accordion').length) {
    accordion();
}

if (document.getElementsByClassName('js-package-select').length) {
    packageSelect();
}

//window.onresize = function () { autoScrollBanner(document.querySelector("#scroll-text")) };
